import React, { useState } from 'react';
import {
  optOutAnalytics,
  dismissAnalyticsNoticeOnly,
  shouldShowAnalyticsNotice,
} from '../analytics';
import './ConsentBanner.css';

export default function ConsentBanner() {
  const [visible, setVisible] = useState(shouldShowAnalyticsNotice);

  const handleDismiss = () => {
    dismissAnalyticsNoticeOnly();
    setVisible(false);
  };

  const handleOptOut = () => {
    optOutAnalytics();
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <div
      className="consent-banner"
      role="region"
      aria-label="Analytics notice"
      data-analytics-ignore="true"
    >
      <div className="consent-banner__content">
        <p className="consent-banner__text">
          We use privacy-friendly analytics to understand how people use this site. Analytics
          runs by default; you can opt out anytime. The site works either way.
        </p>
        <div className="consent-banner__actions">
          <button
            type="button"
            className="consent-banner__button consent-banner__button--primary"
            onClick={handleDismiss}
          >
            Got it
          </button>
          <button type="button" className="consent-banner__button" onClick={handleOptOut}>
            Opt out
          </button>
        </div>
      </div>
    </div>
  );
}
